module.exports = __webpack_public_path__ + "img/quote-background.18aa193c.png";